import {Table, TBody, Td, Th, Thead, Tr} from '@/components';

import type {MetricsData} from './types';
import {formatTime} from './utils';

export interface RawMetricsTableProps {
  data: MetricsData[];
}
export const ratesHeaderHue = 'bg-blue-50 p-8 shadow-sm sticky';
const RawMetricsTable = ({data}: RawMetricsTableProps) => {
  return (
    <Table className="w-full">
      <Thead className={ratesHeaderHue}>
        <Tr enableHover={false}>
          <Th className="px-2">Processor</Th>
          <Th className="px-2">Corridor Pair</Th>
          <Th className="px-2">Payment Instrument</Th>
          <Th className="px-2">Status</Th>
          <Th className="px-2">Total Transactions</Th>
          <Th className="px-2">Successful Transactions</Th>
          <Th className="px-2">Success Rate (%)</Th>
          <Th className="px-2">Average Duration</Th>
          <Th className="px-2">Previous Average Duration</Th>
          <Th className="px-2">Delta Duration</Th>
        </Tr>
      </Thead>

      <TBody>
        {data
          .sort((a, b) => a.percent_st_per_p_cp_pi - b.percent_st_per_p_cp_pi)
          .map((item, index) => (
            <RawMetricsTRow key={index} index={index} item={item} />
          ))}
      </TBody>
    </Table>
  );
};

const RawMetricsTRow = ({item, index}: {item: MetricsData; index: number}) => {
  const zebraRow = index % 2 === 0 ? '' : 'bg-gray-50 dark:bg-dark-zebraRow';
  const {
    processor,
    corridor_pair,
    payment_instrument,
    status,
    total_no_txn_per_p_cp_pi,
    total_no_txn_per_p_cp_pi_st,
    percent_st_per_p_cp_pi,
    avg_duration_per_p_cp_pi_st,
    avg_duration_per_p_cp_pi_st_prev,
    delta_avg_duration_per_p_cp_pi_st,
  } = item;

  return (
    <Tr className={zebraRow}>
      <Td className={`px-2 font-medium`}>{processor}</Td>
      <Td className={`px-2 font-medium`}>
        {corridor_pair.replace('-->', '::')}
      </Td>
      <Td className={`px-2 font-medium`}>{payment_instrument}</Td>
      <Td className={`px-2 font-medium`}>{status}</Td>
      <Td className={`px-2 font-medium`}>{total_no_txn_per_p_cp_pi}</Td>
      <Td className={`px-2 font-medium`}>{total_no_txn_per_p_cp_pi_st}</Td>
      <Td className={`px-2 font-medium`}>
        {percent_st_per_p_cp_pi.toFixed(2)}
      </Td>
      <Td className={`px-2 font-medium`}>
        {formatTime(avg_duration_per_p_cp_pi_st)}
      </Td>
      <Td className={`px-2 font-medium`}>
        {formatTime(avg_duration_per_p_cp_pi_st_prev || 0)}
      </Td>
      <Td className={`px-2 font-medium`}>
        {formatTime(delta_avg_duration_per_p_cp_pi_st || 0)}
      </Td>
    </Tr>
  );
};

export default RawMetricsTable;
